import React from 'react';
import TaskCard from './TaskCard';

const TaskSection = ({ title, tasks, onDeleteTask, onPreviewTask, onOpenErrorTask }) => {
  if (!tasks || tasks.length === 0) return null;

  return (
    <div className="creator-task-section">
      <div className="creator-section-title">{title}</div>
      <div className="creator-task-grid">
        {tasks.map((task) => (
          <TaskCard
            key={task.id}
            task={task}
            onDelete={onDeleteTask}
            onPreview={onPreviewTask}
            onOpenErrorDetail={onOpenErrorTask}
          />
        ))}
      </div>
    </div>
  );
};

export default TaskSection;
